import * as Types from '../types'

export const clearError = actionRoot => {
    return dispatch => {
        dispatch({ type: Types[`CLEAR_${actionRoot}_ERROR`] })
    }
}
